/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagnosisHistory from './diagnosis-history';
import DiagnosisHistoryDetail from './diagnosis-history-detail';
import DiagnosisHistoryUpdate from './diagnosis-history-update';
import DiagnosisHistoryDeleteDialog from './diagnosis-history-delete-dialog';

const DiagnosisHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagnosisHistory />} />
    <Route path="new" element={<DiagnosisHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<DiagnosisHistoryDetail />} />
      <Route path="edit" element={<DiagnosisHistoryUpdate />} />
      <Route path="delete" element={<DiagnosisHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagnosisHistoryRoutes;
